import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "../../api/baseApi";
import { MovieDetails } from "../../../types/movies";

function DetailPage() {
  const [detailData, setDetailData] = useState<MovieDetails>();
  const { movieId } = useParams();
  const fetchUrl = `/movie/${movieId}`;

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await axios.get(fetchUrl);
      setDetailData(data);
    };
    fetchData();
  }, [fetchUrl]);

  if (!detailData) return null;
  return (
    <section>
      <img
        src={`https://image.tmdb.org/t/p/original/${detailData.backdrop_path}`}
        alt="poster"
      />
    </section>
  );
}

export default DetailPage;
